import { WifiOff } from "lucide-react";
import { useOnlineStatus } from "@/application/hooks/useOnlineStatus";
import { useTranslation } from "react-i18next";

export function OfflineBanner() {
  const isOnline = useOnlineStatus();
  const { t } = useTranslation();

  if (isOnline) return null;

  return (
    <>
      {/* Spacer to prevent content overlap */}
      <div className="h-10" />
      <div
        role="alert"
        className="fixed left-0 right-0 top-0 z-50 flex h-10 items-center justify-center gap-2 bg-yellow-500 px-4 py-2 text-center text-sm font-medium text-yellow-900"
      >
        <WifiOff className="h-4 w-4" />
        <span>{t("offline.banner")}</span>
      </div>
    </>
  );
}
